/**
 * Where PANIC sits (2026-10-07, operator: "i don't like the panic button
 * there. maybe that could be in settings? default it to off").
 *
 * PANIC always lives in Settings (Navigate > Settings > Panic). Showing it in
 * Navigate's top bar as well is a per-device choice, OFF by default. Per device
 * because the reason to want it in the bar differs by device: the gig iPad and
 * the desk are not the same question.
 *
 * Off by default leaves three ways to fire it: the button in Settings, a
 * pedal bound in "Panic from a pedal" (fires on OPBridge, tab closed or not),
 * and the search ("panic"). Every storage touch is wrapped: a setting that can
 * throw must never take PANIC with it.
 */

import { createSignal } from 'solid-js';

const KEY = 'opbuttons.panicInTopBar';

function load(): boolean {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

const [inTopBar, setInTopBarSignal] = createSignal<boolean>(load());

/** True when this device shows PANIC in Navigate's top bar too. */
export const panicInTopBar = inTopBar;

export function setPanicInTopBar(on: boolean): void {
  setInTopBarSignal(on);
  try { localStorage.setItem(KEY, on ? '1' : '0'); } catch { /* storage blocked: the choice lasts this session */ }
}
